import { Box, Button, Link, Text } from '@opendoor/bricks-next';
import { LandingPageV2Props } from 'cms';
import { LandingPageSectionContainer } from 'components/landing-pages-v2/shared/Container';
import { CacheSafeGetServerSideProps } from 'declarations/shared/serverSideProps';
import { WithRouterProps } from 'next/dist/client/with-router';
import { withRouter } from 'next/router';

import LandingPageV2Layout, { getLandingpageV2ServerSideProps } from './shared/LandingPageV2Layout';

export const getServerSideProps: CacheSafeGetServerSideProps<LandingPageV2Props> = async (
  context,
) => {
  //Manually setting the slug to fetch the landing Page( with only header and footer) from Contentful.
  context.params = {
    slug: 'error',
  };

  context.query.slug = 'error';
  return getLandingpageV2ServerSideProps(context);
};
export default withRouter(
  (context: React.PropsWithChildren<WithRouterProps> & LandingPageV2Props) => {
    return (
      <LandingPageV2Layout {...context}>
        <RenderErrorPage />
      </LandingPageV2Layout>
    );
  },
);
const RenderErrorPage = () => {
  return (
    <LandingPageSectionContainer
      $largerThanSM={{ width: '40%' }}
      marginTop="$24x"
      justifyContent="space-between"
      marginBottom="15%"
    >
      <Box>
        <Box paddingBottom="$16x">
          <Text tag="h2" typography="$subheaderLarge" paddingBottom="$4x">
            Something went wrong
          </Text>
          <Text tag="h2" typography="$bodyMedium">
            It looks like we ran into an issue while learning about your home. Try again, or start
            over by returning to the homepage.
          </Text>
        </Box>
        <Box paddingBottom="$20x">
          <Button
            onPress={(e) => {
              e.stopPropagation();
              document.location.href = document.referrer;
            }}
            analyticsName="cosmos-error-try-again-button"
            variant="primary"
            size="small"
            label="Try again"
            marginBottom="$4x"
          />
          <Button
            onPress={(e) => {
              e.stopPropagation();
              document.location.href = 'https://www.opendoor.com';
            }}
            analyticsName="cosmos-error-return-to-homepage-button"
            variant="secondary"
            size="small"
            label="Return to homepage"
          />
        </Box>
        <Box display="flex" flexDirection="row" alignItems="center" flexWrap="wrap" gap="$2x">
          <Text tag="span" typography="$bodySmall">
            Contact us at
          </Text>
          <Link
            aria-label={`opendoor-error-contact-email`}
            href={'mailto:support@opendoor.com'}
            size={'small'}
            analyticsName={`cosmos-error-page-contact-support`}
            color="$contentPrimary"
            variant="primary"
          >
            support@opendoor.com
          </Link>
          <Text tag="span" typography="$bodySmall">
            or
          </Text>
          <Link
            aria-label={`opendoor-error-contact-email`}
            href={'tel:888-352-7075'}
            size={'small'}
            analyticsName={`cosmos-error-page-contact-support`}
            color="$contentPrimary"
            variant="primary"
          >
            888-352-7075
          </Link>
          <Text tag="span" typography="$bodySmall">
            if this happens again.
          </Text>
        </Box>
      </Box>
    </LandingPageSectionContainer>
  );
};
